import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './utils/api'
import store from './store'
import imageUrlPlugin from './plugins/image-url';

Vue.prototype.$api = api

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
Vue.use(ElementUI)
Vue.use(imageUrlPlugin);
new Vue({
  router,   // 注册路由
  store,
  render: h => h(App),
}).$mount('#app')
